export default __webpack_public_path__ + "static/01-01-reading-science-articles-e05c5052da2de9ca31a5c8a47129e07e.mp4";